import { useMemo } from 'react';

/**
 * Hook to determine the data visibility scope for the current user.
 * Returns lists of allowed IDs for factories, door groups, and docks.
 */
export const useDataScope = (userData) => {
    return useMemo(() => {
        if (!userData) {
            return {
                isFullAccess: false,
                factoryIds: [],
                doorGroupIds: [],
                dockIds: []
            };
        }

        const isSuperUser = userData.role === 'consultant';
        const isCoordinator = userData.role === 'coordinator';

        // Full access for Super Admins and Tenant Coordinators (by default)
        if (isSuperUser || isCoordinator) {
            return {
                isFullAccess: true,
                factoryIds: [],
                doorGroupIds: [],
                dockIds: []
            };
        }

        // Granular access for other roles (Gate Staff, Dock Staff, etc.)
        const scope = userData.scope || {};

        return {
            isFullAccess: false,
            factoryIds: scope.factoryIds || [],
            doorGroupIds: scope.doorGroupIds || [],
            dockIds: scope.dockIds || []
        };
    }, [userData]);
};
